"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerVoiceLanguages = void 0;
const enums_1 = require("../../enums");
exports.ProducerVoiceLanguages = [
    {
        languageId: enums_1.ProducerEventVoiceLanguage.enUS,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.enUSAriaNeural, name: "Aria", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.enLunaNeural, name: "Luna", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.enAmandaMultilingualNeural, name: "Amanda", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.enUSGuyNeural, name: "Guy", gender: enums_1.ProducerGender.Male },
            { id: enums_1.ProducerEventVoiceActor.enDavisNeural, name: "Davis", gender: enums_1.ProducerGender.Male },
            { id: enums_1.ProducerEventVoiceActor.enKaiNeural, name: "Kai", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.enGB,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.enGBMiaNeural, name: "Mia", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.enGBRyanNeural, name: "Ryan", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.enIE,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.enIEEmilyNeural, name: "Emily", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.enIEConnorNeural, name: "Connor", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.esEs,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.esESElviraNeural, name: "Elvira", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.esESAlvaroNeural, name: "Alvaro", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.gaIE,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.gaIEOrlaNeural, name: "Orla", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.gaIEColmNeural, name: "Colm", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.frCA,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.frCASylvieNeural, name: "Sylvie", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.frCAAntoineNeural, name: "Antoine", gender: enums_1.ProducerGender.Male },
        ],
    },
    {
        languageId: enums_1.ProducerEventVoiceLanguage.svSE,
        voiceActors: [
            { id: enums_1.ProducerEventVoiceActor.svSESofieNeural, name: "Sofie", gender: enums_1.ProducerGender.Female },
            { id: enums_1.ProducerEventVoiceActor.svSEMattiasNeural, name: "Mattias", gender: enums_1.ProducerGender.Male },
        ],
    },
];
//# sourceMappingURL=voiceLanguage.js.map